import { FC } from 'react';
import { Button, Input, Typography } from 'antd';
import { useDispatch } from 'react-redux';
import { isMobile } from 'react-device-detect';

import { Verify2FAStepProps } from 'models/form';

import Utils from 'utils/utils';

import { useAppSelector, useTranslate } from 'hooks';

import { setVerify2FAStep } from 'features/verify2FA/verify2FASlice';

import { ReactComponent as CopyIcon } from 'assets/icons/copy.svg';

export const VerifyQrCode: FC<Verify2FAStepProps> = () => {
	const qr = useAppSelector((state) => state.verify2FA.qrCode);

	const { continueText, scanQrText, cantScanText, copyOrEnterCodeText } = useTranslate([
		'continueText',
		'scanQrText',
		'cantScanText',

		'copyOrEnterCodeText',
	]);

	const dispatch = useDispatch();

	return (
		<div className="modal-content">
			{isMobile ? '' : <Typography.Text>{scanQrText}</Typography.Text>}
			{isMobile ? '' : <img src={qr.tfa_qr_uri} alt="qr" className="modal-qr" />}
			<Typography.Text>{isMobile ? copyOrEnterCodeText : cantScanText}</Typography.Text>
			<div className="modal-input">
				<Input disabled={true} value={qr.tfa_secret} />

				<Button
					className="modal-copy"
					onClick={() => Utils.copyText(qr.tfa_secret)}
					type="link"
					icon={<CopyIcon className="copyIcon" />}
				/>
			</div>
			<Button type="primary" className="modal-button" onClick={() => dispatch(setVerify2FAStep(2))}>
				{continueText}
			</Button>
		</div>
	);
};
